import clsx from 'clsx';

export type CommentHighlightState = 'none' | 'pending' | 'saved' | 'active';

const INLINE_BASE_CLASSES = 'rounded-xxs box-decoration-clone text-inherit';

const ROW_BASE_CLASSES =
    "pr-[calc(var(--spacing-s)-1px)] before:pointer-events-none before:absolute before:inset-y-[calc(var(--spacing-s)-1px)] before:-left-px before:right-0 before:rounded-[calc(var(--radius-md)+1px)] before:transition-[background-color] before:duration-200 before:content-['']";

const ACTIVE_INLINE_CLASSES = 'bg-orange-300 dark:bg-comment-highlight-active-surface!';

const ACTIVE_ROW_CLASSES = 'before:bg-orange-300 dark:before:bg-comment-highlight-active-surface!';

export const commentHighlightStateClasses: Record<CommentHighlightState, string> = {
    none: 'bg-transparent',
    saved: 'bg-orange-100 dark:bg-comment-highlight-surface!',
    active: ACTIVE_INLINE_CLASSES,
    pending: ACTIVE_INLINE_CLASSES,
};

const ROW_STATE_CLASSES: Record<CommentHighlightState, string> = {
    none: '',
    saved: 'before:bg-orange-100 dark:before:bg-comment-highlight-surface!',
    active: ACTIVE_ROW_CLASSES,
    pending: ACTIVE_ROW_CLASSES,
};

export const commentHighlightClassName = (state: CommentHighlightState): string =>
    clsx(INLINE_BASE_CLASSES, commentHighlightStateClasses[state]);

export const commentHighlightRowClassName = (state: CommentHighlightState): string =>
    state === 'none' ? '' : clsx(ROW_BASE_CLASSES, ROW_STATE_CLASSES[state]);
